<template>
  <Card
    style="height: calc(100vh - 250px)"
    full-height
  >
    <CardBody class="overflow-y-scroll">
      <AgreementTimeline
        :items="localTimelineData"
        :agreement-i-d="agreementID"
        @update:items="handleTimelineUpdate"
        @note-added="$emit('note-added', $event)"
        @edit-note="$emit('edit-note', $event)"
      />
    </CardBody>
  </Card>
</template>

<script setup lang="ts">
// composables
import { computed } from 'vue'
// components
import Card from '@/components/card/Card.vue'
import CardBody from '@/components/card/CardBody.vue'
import AgreementTimeline from '@/components/unique/agreement/AgreementTimeline.vue'
// types
import type { AgreementTimelineItemEnriched } from '@/types/domain/agreementTimeline'

interface Props {
  agreementID: string | number
  timelineData: AgreementTimelineItemEnriched[]
}

const props = defineProps<Props>()

const emit = defineEmits<{
  'note-added': [item: AgreementTimelineItemEnriched]
  'edit-note': [item: AgreementTimelineItemEnriched]
  'update:timelineData': [items: AgreementTimelineItemEnriched[]]
}>()

// Local computed for timeline data to allow v-model
const localTimelineData = computed({
  get: () => props.timelineData,
  set: value => {
    emit('update:timelineData', value)
  }
})

/**
 * Handles timeline items update
 * @param items - Updated timeline items
 */
function handleTimelineUpdate(items: AgreementTimelineItemEnriched[]): void {
  emit('update:timelineData', items)
}
</script>
